var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.countdown === 0)?_c('button',{staticClass:"weui-vcode-btn",on:{"click":_vm.getLoginSmsCode}},[_vm._v("发送验证码")]):_c('span',{staticClass:"weui-vcode-btn counting-down"},[_vm._v(_vm._s(_vm.countdown)+"秒后重发")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e38f1cd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/VcodeButton.vue
// module id = null
// module chunks = 